import type PostalAddressType from 'owa-service/lib/contract/PostalAddressType';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import type { BookingPostalAddress, BookingLocationCoordinates } from 'owa-graph-schema';

const mapBookingPostalAddress = (
    address: BookingPostalAddress,
    coordinates?: BookingLocationCoordinates
): EnhancedLocation | undefined => {
    if (!address) {
        return;
    }
    const {
        name,
        street,
        city,
        state,
        countryOrRegion,
        postalCode,
        postOfficeBox,
        type,
        locationSource,
    } = address;
    const { latitude, longitude } = coordinates ?? {};
    const isCoordinatesPresent = latitude !== 0 || longitude !== 0;
    const modifiedAddress: EnhancedLocation = {
        DisplayName: name ?? '',
        PostalAddress: {
            Street: street ?? '',
            City: city ?? '',
            State: state ?? '',
            Country: countryOrRegion ?? '',
            PostalCode: postalCode ?? '',
            PostOfficeBox: postOfficeBox ?? '',
            Type: (type ?? 'Home') as PostalAddressType,
            LocationSource: locationSource ?? 'None',
            Latitude: isCoordinatesPresent ? (latitude as number) : undefined,
            Longitude: isCoordinatesPresent ? (longitude as number) : undefined,
        },
    };
    return modifiedAddress;
};

export default mapBookingPostalAddress;
